import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Competency } from './Competency'
import { client } from '../../utils'

export const App = props => {
  const [competencies, setCompetencies] = useState(props.competencies)
  const [competency, setCompetency] = useState('')
  const [isNew, setIsNew] = useState(false)

  const setIsNewMode = () => {
    setIsNew(!isNew)
  }

  const SubmitCompetency = e => {
    e.preventDefault()
    let sortOrder = 0
    if (competencies.length > 0) {
      const lastComp = competencies[competencies.length - 1]
      sortOrder = lastComp.sortOrder + 1
    }
    let data = {
      text: competency,
      sort_order: sortOrder,
    }
    client
      .post(`/api_v2/competencies/${props.coursenum}`, data)
      .then(resp => {
        console.log(resp)
        addCompetency(resp.data.competency)
        setCompetency('')
        setIsNew(false)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const addCompetency = newComp => {
    let newCompetencies = [...competencies]
    newCompetencies.push(newComp)
    setCompetencies(newCompetencies)
  }

  const editCompetency = newComp => {
    let competenciesDraft = [...competencies]
    for (let i = 0; i < competenciesDraft.length; i++) {
      if (competenciesDraft[i].id === newComp.id) {
        competenciesDraft[i] = newComp
      }
    }
    setCompetencies(competenciesDraft)
  }

  const removeCompetency = id => {
    let filterCompetencies = competencies.filter(function (obj) {
      return obj.id !== id
    })
    setCompetencies(filterCompetencies)
  }

  const move = (index, step) => {
    let movedCompetencies = [...competencies]
    let tmp = movedCompetencies[index]
    movedCompetencies[index] = movedCompetencies[index + step]
    movedCompetencies[index + step] = tmp
    let compIds = movedCompetencies.reduce((acc, currComp) => {
      acc.push(currComp.id)
      return acc
    }, [])
    client
      .put(`/api_v2/competencies/${props.coursenum}/sort_order`, { compIds })
      .catch(err => {
        console.log(err)
      })
    setCompetencies(movedCompetencies)
  }

  const competencyHtml = isNew && (
    <tr>
      <td />
      <td className="w-200">
        <form className="tagline" onSubmit={e => SubmitCompetency(e)}>
          <label htmlFor={`comp-new`}>
            <h4>New Competency</h4>
          </label>
          <textarea
            onChange={e => setCompetency(e.target.value)}
            id={`comp-new`}
            className="w-100"
            name="desc"
            type="text"
            value={competency}
            placeholder="Enter competency here..."
          />
          <button
            className="btn btn-success"
            type="submit"
            disabled={competency === ''}
          >
            Submit Competency
          </button>
        </form>
      </td>
    </tr>
  )

  const addButton = isNew ? (
    <button
      onClick={setIsNewMode}
      className="btn btn-danger pull-right"
      type="submit"
    >
      Cancel Competency
    </button>
  ) : (
    <button
      onClick={setIsNewMode}
      className="btn btn-myed btn-primary btn-primary-myed pull-right"
      type="submit"
    >
      New Competency
    </button>
  )
  return (
    <div>
      <table className="w-100">
        <tbody>
          {competencies.map((element, idx) => {
            return (
              <Competency
                key={idx}
                index={idx}
                comp={element}
                editCompetency={editCompetency}
                removeCompetency={removeCompetency}
                move={move}
                showUp={idx > 0}
                showDown={idx !== competencies.length - 1}
              />
            )
          })}
          {competencyHtml}
        </tbody>
      </table>
      {addButton}
    </div>
  )
}

App.propTypes = {
  coursenum: PropTypes.string.isRequired,
  competencies: PropTypes.array.isRequired,
}
